'use strict';

var parseImportDateTime = require('./parseImportDateTime');

var autoImportCtrl = ['$state', '$scope', '$timeout', 'Department', 'Client', 'Member', 'toast', 'dialog', '$translate', '$uibModal', function ($state, $scope, $timeout, Department, Client, Member, toast, dialog, $translate, $uibModal) {
    $state.importTasks = {};
    $scope.content = "";
    var _this = this;
    this.idCalc = Math.random().toString(36).substr(2, 9)
    
    $scope.estado = "";
    _this.processed = false;
    
    _this.data = [];
    _this.tabChar = ";"
    _this.firstRowTitlesArray = [];
    _this.maxCol = 0;
    _this.requiredTitles = [
        'FECHA',            // col1
        'HORA_INICIO',      // col2
        'HORA_FIN',         // col3
        'NOMBRE_TAREA',     // col4
        'DESCRIPTION_TAREA',// col5
        'NOMBRE_FORMULARIO',// col6
        'USUARIO_EMAIL',    // col7
        'SITIO'             // col8
    ]

    _this.colDate = "col1";
    _this.colStart = "col2";
    _this.colEnd = "col3";
    _this.colTaskName = "col4";
    _this.colTaskDescription = "col5";
    _this.colFormName = "col6";
    _this.colUserEmail = "col7";
    _this.colSite = "col8";

    _this.sitios = {};
    _this.members = [];
    _this.notFoundEmails = [];
    _this.forms = [];
    _this.notFoundForms = [];

	_this.clearFileInput = function () {
		if ($scope.content === '' && _this.data.length === 0) {
			_this.data = [];
            _this.firstRowTitlesArray = [];
            _this.notFoundForms = [];
            _this.notFoundEmails = [];
			_this.openNewFile();
		} else {
			dialog.confirm({
				title: $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.SELECT_FILE"),
				body: $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.DIALOG_CONFIRM.BODY"),
				accept: $translate.instant("DASHBOARD.ACCEPT"),
				cancel: $translate.instant("DASHBOARD.CANCEL"),
				size: "md",
			})
				.then(function () {
					// Clear content, data, delete first row checkbox.
					$scope.content = "";
					_this.data = [];
                    _this.firstRowTitlesArray = [];
                    _this.notFoundForms = [];
                    _this.notFoundEmails = [];

                    $scope.estado = "";
                    _this.processed = false;

                    _this.openNewFile();
				});
		}
	};

	_this.openNewFile = function () {
		// Create file input, open the file selection window, asign value to content.
		var input = document.createElement('input');
		input.type = 'file';
		input.style.display = 'none';
		document.body.appendChild(input);

		input.addEventListener('change', function () {
			var file = input.files[0];
			var reader = new FileReader();
			reader.onload = function (event) {
				$scope.$apply(function () {
					$scope.content = event.target.result;
				});
			};
			reader.readAsText(file);

			_this.content = JSON.parse(JSON.stringify(reader));
		});

		input.click();
	}

    _this.processContent = function (generateTasks) {
        $scope.estado = "";

        _this.data = [];
        _this.maxCol = 0;
        var tabCharValue = ';';
        if (_this.tabChar == "TAB") { tabCharValue = "\t"; }
        
        localStorage.setItem("advancedCharSeparator", JSON.stringify(_this.tabChar));

        var contentCopy = ($scope.content || '').replace(/^\uFEFF/, '');

        // Remove first row (column titles), save first row in another variable
        var firstRowTitlesEndIndex = contentCopy.indexOf('\n') + 1;
        var firstRowTitles = contentCopy.substring(0, firstRowTitlesEndIndex);
        contentCopy = contentCopy.substring(firstRowTitlesEndIndex);

        // Remove line endings from firstRowTitles
        firstRowTitles = firstRowTitles.replace(/\r?\n|\r/g, '');

        // Process the first line to obtain the column titles
        var firstRowCols = firstRowTitles.split(tabCharValue);
        _this.firstRowTitlesArray = [];
        for (var i = 0; i < firstRowCols.length; i++) {
            var cleanTitle = firstRowCols[i].replace(/^["']|["']$/g, ''); // Remove single and double quotes at the beginning and end of each data.
            _this.firstRowTitlesArray.push(cleanTitle);
        }

        // Variable to store if all titles match
        var requiredTitlesMatch = true;

        // Check if required titles are in the same position in the uploaded file
        for (var i = 0; i < _this.requiredTitles.length; i++) {
            var requiredTitle = _this.requiredTitles[i];

            // Check if the required title is in the same position in the second array
            if (i < _this.firstRowTitlesArray.length && requiredTitle !== _this.firstRowTitlesArray[i]) {
                requiredTitlesMatch = false;
                break;
            }
        }

        // If all titles match, continue with the process
        if (requiredTitlesMatch) {
                
            var lines = contentCopy.split(/\r?\n|\r/); // delete \r\n
    
            for (var j = 0; j < lines.length; j++) {
                var f = lines[j];
                var fila = {};
                if (f.trim() != "") {
                    var cols = f.split(tabCharValue);
                    for (var i = 0; i < cols.length; i++) {
                        var cleanData = cols[i].replace(/^["']|["']$/g, ''); // Remove single and double quotes at the beginning and end of each data.
                        fila["col" + (i + 1)] = cleanData;
    
                        if (i + 1 > _this.maxCol) _this.maxCol = i + 1;
                    }
                    _this.data.push(fila);
                }
            }

            _this.columnDefs = []
            for (var i = 1; i <= _this.maxCol; i++) {
                let title = _this.firstRowTitlesArray[i - 1];

                // Resize width
                let width;

                // width based on string length
                if (title.length < 7) {  width = 90;
                } else if (title.length <= 11) { width = 100;
                } else if (title.length <= 14) { width = 130;
                } else if (title.length <= 18) { width = 160;
                } else { width = 180;
                }
                _this.columnDefs.push({ headerName: _this.firstRowTitlesArray[i - 1], field: "col" + i, width: width, editable: true });
            }
    
            // $timeout is necessary to fully load the table
            $timeout(() => {
                _this.gridOptions.api.setColumnDefs(_this.columnDefs);
                _this.gridOptions.api.setRowData(_this.data);

                $state.importTasks["data"] = _this.data;
                $state.importTasks["colnumber"] = _this.maxCol;
    
                _this.scrollpagedown();

                if (generateTasks) {
                    _this.generateTasks();
                } else {
                    this.processed = true;
                }
            }, 300);



        } else {
            // Error message.
            this.errorMessage(
                $translate.instant("DASHBOARD.DASH_TASKS.FIELDS.ERROR_DEFAULT_TITLES"),
                $translate.instant("DASHBOARD.DASH_TASKS.FIELDS.ERROR_DEFAULT_TITLES_BODY")
            );
            return
        }

    }

    _this.columnDefs = [];
    _this.gridOptions = {
        headerHeight: 40,
        columnDefs: _this.columnDefs,
        enableSorting: true,
        enableColResize: true,
        angularCompileRows: true,
        angularCompileFilters: true,
        angularCompileHeaders: true,
        rowData: []
    };

    _this.generateTasks = function() {
        _this.sitios = {}
        this.randomColor = Math.floor(Math.random() * 200) + 160;
        this.currentRow = -1;
        _this.newTasks = [];
        toast.loading("Creando Tareas...", "importTasks");

        Client.find()
        .$promise
        .then(function (clients) {
            clients.map(function (client) {
                _this.sitios[client.name] = client.id
            });

            _this.nextRowData();
        })
        .catch(function (error) {
            console.log(error);
            _this.stopImport(
                $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.ERROR_SAVE_TITLE"),
                _this.getImportErrorDetail(error)
            );
        });
    }

    _this.nextRowData = function () {
        this.currentRow = this.currentRow + 1;
        
        if (this.currentRow >= _this.data.length) {
            const taskWithoutDates = _this.newTasks.find(function (t) {
                return !parseImportDateTime.isValid(t.startDate) || !parseImportDateTime.isValid(t.endDate);
            });
            if (taskWithoutDates) {
                _this.stopImport(
                    $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.ERROR_DATE_TITLE"),
                    $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.ERROR_DATE_API")
                );
                return;
            }

            var payload = {
                tasks: _this.newTasks,
                userIds: []
            };

            Department.addTasks({
                departmentId: $state.params.departmentId
            }, payload)
                .$promise
                .then(function () {
                    toast.closeLoaders("importTasks");
                    $scope.estado = "";

                    _this.errorMessage(
                        // "Tareas avanzadas",
                        $translate.instant('DASHBOARD.DASH_TASKS_ADVANCED.TITLE'),
                        // "Se finalizó la importación automática de tareas."
                        $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.INFO_IMPORT_END")
                    )

                    // INFORM NOT FOUND EMAILS                    
                    if (_this.notFoundEmails.length > 0) {
                        // New with no duplicate emails
                        let uniqueEmailsSet = new Set(_this.notFoundEmails);
                        // Convert Set to new array
                        let uniqueEmailsArray = Array.from(uniqueEmailsSet);
                        let emailsString = uniqueEmailsArray.slice(0, -1).join(', ');
                        emailsString += (uniqueEmailsArray.length > 1 ? ', ' : '') + uniqueEmailsArray[uniqueEmailsArray.length - 1];
                        
                        _this.errorMessage(
                            $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.ERROR_USERS_NOT_FOUND_TITLE"),
                            $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.ERROR_USERS_NOT_FOUND_BODY") + emailsString
                        )
                    }

                    $state.reload('dashboard.departments.department.tasksAdvanced')
                        .then(function () {
                            $state.go('dashboard.departments.department.tasksAdvanced');
                        });
                })
                .catch(function (error) {
                    console.log(error);
                    _this.stopImport(
                        $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.ERROR_SAVE_TITLE"),
                        _this.getImportErrorDetail(error)
                    );
                });

            return;
        }
        else {

            $scope.estado = "Procesando " + (this.currentRow + 1) + " / " + _this.data.length;
        
            let tarea = _this.data[this.currentRow]
            let task = {}
            
            // name
            task.name = tarea[_this.colTaskName]
            
            // description
            task.description = tarea[_this.colTaskDescription]

            // formId: "60cbdb217de62a2c7d99ac54"
            var formName = tarea[_this.colFormName]
            var formIndex = _this.forms.findIndex(function (form) {
                return (formName === form.name);
            })
            if (formIndex !== -1) {
                // Save formId
                task.formId = _this.forms[formIndex].id;
            }
            else {
                // Error Message: Forms.
                this.stopImport(
                    $translate.instant("DASHBOARD.DASH_TASKS.FIELDS.ERROR_FORM_TITLE"),
                    $translate.instant("DASHBOARD.DASH_TASKS.FIELDS.ERROR_FORM_MESSAGE_START") +
                    formName
                    + $translate.instant("DASHBOARD.DASH_TASKS.FIELDS.ERROR_FORM_MESSAGE_END"),
                );
                return;
            }

            // If firstRowTitles has more fields than requiredTitles, it's because metadata was added.
            if (_this.firstRowTitlesArray.length > _this.requiredTitles.length) {
                // Build payload and fields
                task.payload = [];
                task.payloadHidden = {};

                for (var i = _this.requiredTitles.length; i < _this.firstRowTitlesArray.length; i++) {
                    let keyName = _this.firstRowTitlesArray[i]
                    var meta = {
                        key: keyName,
                        value: tarea['col' + (i + 1)],
                        fieldId: null,
                        id: _this.idCalc + i, // This is to assign every column the same id.
                    }
                    task.payload.push(meta);
    
                    task.payloadHidden[keyName] = false;
                }
            }
            
            // startDate: "2024-02-25T09:00:00.000Z"
            // endDate: "2024-02-25T17:00:00.000Z"
            let day =  tarea[_this.colDate];
            let startHour =  tarea[_this.colStart];
            let endHour =  tarea[_this.colEnd];
            task.startDate = parseImportDateTime(day, startHour);
            task.endDate = parseImportDateTime(day, endHour);
            if (!task.startDate || !task.endDate) {
                _this.stopImport(
                    $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.ERROR_DATE_TITLE"),
                    $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.ERROR_DATE_MESSAGE_START") +
                    (_this.currentRow + 1) +
                    $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.ERROR_DATE_MESSAGE_MID") +
                    day + ' ' + startHour + ' / ' + endHour +
                    $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.ERROR_DATE_MESSAGE_END")
                );
                return;
            }
    
            // allDay: false
            task.allDay = false;
    
            // color: "hsl(305,100%,25%)"
            task.color = 'hsl(' + this.randomColor + ',100%,25%)';
    
            // repeat: false
            task.repeat = false;

            // repeatData: {}
            task.repeatData = {};
            
            const emails = _this.splitEmailListForImport(tarea[_this.colUserEmail]);
            task.userIds = [];
            for (let i = 0; i < emails.length; i++) {
                const emailNorm = emails[i].toLowerCase();
                const memberIndex = _this.members.findIndex(function (member) {
                    return member.email && emailNorm === member.email.toLowerCase();
                });

                if (memberIndex !== -1) {
                    task.userIds.push(_this.members[memberIndex].id);
                } 
                else {
                    _this.notFoundEmails.push(emails[i]);
                }
            }

            // Get clientId from site name; if it doesn't exist, create it.
            let clientNameCol = (tarea[_this.colSite] || '').trim();
            if (clientNameCol === '') {
                this.stopImport(
                    $translate.instant("DASHBOARD.DASH_TASKS.FIELDS.ERROR_SITE_TITLE"),
                    $translate.instant("DASHBOARD.DASH_TASKS.FIELDS.ERROR_SITE_MESSAGE_START") +
                    clientNameCol
                    + $translate.instant("DASHBOARD.DASH_TASKS.FIELDS.ERROR_SITE_MESSAGE_END"),
                );
                return;
            }

            if (this.sitios[clientNameCol]) {
                task.clientId = this.sitios[clientNameCol];
                this.addTask(task);
            } else {
                let client = {
                    name: clientNameCol,
                    fromImport: true
                };

                Client.upsert(client)
                    .$promise
                    .then(function (clientCreated) {
                        _this.sitios[clientNameCol] = clientCreated.id;
                        task.clientId = _this.sitios[clientNameCol];
                        _this.addTask(task);
                    })
                    .catch(function (error) {
                        console.log(error);
                        _this.stopImport(
                            $translate.instant("DASHBOARD.DASH_TASKS.FIELDS.ERROR_SITE_TITLE"),
                            $translate.instant("DASHBOARD.DASH_TASKS.FIELDS.ERROR_SITE_MESSAGE_START") +
                            clientNameCol
                            + $translate.instant("DASHBOARD.DASH_TASKS.FIELDS.ERROR_SITE_MESSAGE_END"),
                        );
                    });
            }
        }

    }

    this.addTask = function (task) {
        _this.newTasks.push(task);
        this.teamMembers = _this.nextRowData();
    }

    this.stopImport = (title, body) => {
        toast.closeLoaders("importTasks");
        $scope.estado = '';
        _this.errorMessage(title, body);
    }

    this.getImportErrorDetail = (error) => {
        const apiError = error && error.data && error.data.error;
        const codes = apiError && apiError.details && apiError.details.codes;
        const dateMissing = codes && (
            (codes.startDate && codes.startDate.indexOf('presence') !== -1) ||
            (codes.endDate && codes.endDate.indexOf('presence') !== -1)
        );
        if (dateMissing) {
            return $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.ERROR_DATE_API");
        }
        if (apiError && apiError.message) {
            return apiError.message;
        }
        return $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.ERROR_SAVE_BODY");
    }

    this.errorMessage = function(title, error) {
        dialog.alert({
            title: title,
            body: error,
            close: $translate.instant("DASHBOARD.CLOSE"),
            size: 'md'
        });
    }

    _this.getAdvancedCharSeparator = function() {
        var separatorLocalStorage = localStorage.getItem('advancedCharSeparator');
            if (separatorLocalStorage !== "undefined" && separatorLocalStorage !== null) {
                _this.tabChar = JSON.parse(separatorLocalStorage);
            }
    }

    this.getMembers = function () {
        return Member.find()
        .$promise
        .then(function (members) {
            _this.members = [...members];
        })
    }

    this.getForms = function () {
        var query = {
            id: $state.params.departmentId
        };

        return Department.forms(query)
            .$promise
            .then(function (forms) {
                _this.forms = forms;
                return forms
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    /**
     * Separa varios correos en una celda (importación TSV/CSV).
     * Acepta coma, punto y coma, comas tipográficas/árabe y saltos de línea; recorta espacios.
     */
    this.splitEmailListForImport = (cell) =>{
        if (cell == null || cell === '') {
            return [];
        }
        return String(cell)
            .split(/[,;\uFF0C\u060C\r\n]+/)
            .map(function (part) {
                return part.trim();
            })
            .filter(function (part) {
                return part.length > 0;
            });
    }

    this.helpFile = function() {
        $uibModal.open({
            animation: true,
            controller: ['$uibModalInstance', function($uibModalInstance) {
                var _this = this;
                this.fileExample = "ID TAREA    ESTADO  EMPRESA USUARIO FECHA   INICIO  FIN\nA_1623581718	Abierta	HARVEST ENERGY S.R.L.	gomezjuan@gmail.com	2024-02-22	09:00	17:00\nA_8632057025	Abierta	PECOM	perezmaria@gmail.com	2024-02-23	10:00	18:00\nA_6322227377	Abierta	ROWING lopezana@gmail.com	2024-02-24	08:30	16:30\n"
            }],
            templateUrl: 'dashboard-tasks-advanced/imports/helpFile.html',
            controllerAs: 'modal',
            size: 'lg',
            windowClass: 'dialog',
            bindToController: true
        })
    };

    _this.getAdvancedCharSeparator();
    _this.getMembers();
    _this.getForms();
    
}];

module.exports = function () {
	return {
		restrict: 'E',
		scope: {
			close: '=',
            scrollpagedown: '=',
		},
		controller: autoImportCtrl,
		controllerAs: 'ctrl',
		bindToController: true,
		templateUrl: 'dashboard-tasks-advanced/imports/auto-import.html',
	};
};
